<app-page-detail [id]="id" [crud]="service" [(model)]="model" [(form)]="form" [reload]="reload">
  <div class="flex flex-column md:flex-row gap-3 w-full justify-content-around p-3">
    <div class="flex flex-column gap-3 w-12">
      <app-editable-card title="Informazioni" [form]="form" [crud]="service" [(model)]="model">
        <app-text-field label="Id. ARERA" [value]="model()?.idAto ?? '_idAto'"></app-text-field>
        <app-text-field label="Denominazione" [value]="model()?.ato ?? '_Denominazione'"></app-text-field>
        <div card-form>
          <app-key-value-form [form]="form" keyField="idAto" keyLabel="Id. ARERA" valueField="ato" valueLabel="Denominazione"></app-key-value-form>
        </div>
      </app-editable-card>
    </div>
  </div>
</app-page-detail>
